RivalIQ.module('suggestion.models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Suggestion = Backbone.Model.extend({
        defaults: {
            companyId: null,
            type: null,
            message: null
        },

        url: function () {

            return `/api/dataChangeRequest/${this.get('companyId')}`;
        },

        validate: function () {
            const errors = [];
            _.each(this.toJSON(), function (value, key) {
                if (value === null) {
                    errors.push(key);
                }
            });

            if (errors.length > 0) {
                return this.buildErrorString(errors);
            }
        },

        buildErrorString: function (errors) {
            return `Basic validation found the following (required) fields missing: ${errors.join(', ')}`;
        }
    });
});
